<template>
	<div class="project-dtails">
		<div class="title">
			<span>{{projectDetails.name}}</span>
			<span class="viewCount">发布日期：{{projectDetails.createTime}}&nbsp;&nbsp;&nbsp;&nbsp;浏览次数：45次</span>
		</div>
		<el-divider></el-divider>
		<div class="details-text">
			<p> {{projectDetails.textContext}}</p>
			<el-image :src="'/file/project/yijian/'+projectDetails.id+'/img.png'"></el-image>
			<div>
				<p>访问地址：<!-- <font color='blue'>{{projectDetails.address}}</font> -->
					<el-button type="text" class="openCourseBtn" @click="openCourse(projectDetails)">{{projectDetails.address}}</el-button>
				</p>
				<p>账号：{{projectDetails.loginID}}</p>
				<p>密码：{{projectDetails.password}}</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			projectDetails: {
				type: Object
			}
		},
		created() {
			// console.log(this.projectDetails)
		},
		methods: {
			openCourse(val) {
				// localStorage.setItem('openCoursePage', val.cid)
				window.open(val.address+'?openCoursePage='+val.cid, '_blank')
			}
		}
	}
</script>

<style lang="scss">
	.project-dtails {

		.title {
			line-height: 50px;
			font-weight: bold;

			.viewCount {
				float: right;
				color: #4b4b4b;
				font-size: 14px;
				font-weight: 100;
			}
		}

		.el-divider {
			margin: 0;
			margin-bottom: 20px;
		}

		.details-text {
			// text-align: center;
			// text-indent: 2em;

			.openCourseBtn {
				color: blue;
			}
		}
	}
</style>